// import { Injectable } from '@angular/core';
// import { HttpClient, HttpHeaders } from '@angular/common/http';
// import { UserAuthModel } from '../models/user-auth.model';
// import { Observable, BehaviorSubject } from 'rxjs';
// import { ConfigService } from './config.service';
// import { LoginModel } from '../models/login.model';

// const httpOptions = {
//   headers: new HttpHeaders({
//     'Content-Type': 'application/x-www-form-urlencoded',
//     'timeout': '5000',
//     'Autologin': 'true'
//   })
// };

// @Injectable({
//   providedIn: 'root'
// })
// export class AuthService {

//   private authUser = new BehaviorSubject<UserAuthModel>(null);

//   constructor(
//     private httpClient: HttpClient,
//     private configService: ConfigService) { }

//   autoLogin()
//   {
//     return this.httpClient.get<UserAuthModel>(this.configService.getWebAPIurl() + "API/Authentication/Authentication/AutoLogin",httpOptions);
//   }

//   logonUser(login: LoginModel): Observable<UserAuthModel> {
//     return this.httpClient.post<UserAuthModel>(this.configService.getWebAPIurl() + 'API/Authentication/Authentication/LogonUser', JSON.stringify(login));
//   }

//   setAuthentication(authUserModel: UserAuthModel) {
//     this.authUser.next(authUserModel);
//   }

//   getAuthentication(): Observable<UserAuthModel> {
//       return this.authUser.asObservable();
//   }
// }

import { Injectable } from "@angular/core";
import 'rxjs';

import { LoginModel } from '../models/login.model';
import { UserAuthModel } from '../models/user-auth.model';
import { Observable, BehaviorSubject } from 'rxjs';

import { AppInjector } from '../../../app/app.injector';
import { ConfigService } from './config.service';
import { HttpClient } from '@angular/common/http';
import { UserInterfaceService } from './user-interface.service';
import { AnagraficaModel } from "app/reports/shared/models/anagrafica.model";

@Injectable()
export class AuthService {

  private authUser = new BehaviorSubject<UserAuthModel>(null);
  private configService: ConfigService;
  public http;
  
  constructor(

   public userInterfaceService: UserInterfaceService
 ){
  this.http = AppInjector.get(HttpClient);
  this.configService = AppInjector.get(ConfigService);
 }


  doLogout(){
    // return new Promise((resolve, reject) => {
    //   if(firebase.auth().currentUser){
    //     this.afAuth.auth.signOut();
    //     resolve();
    //   }
    //   else{
    //     reject();
    //   }
    // });
  }

    setAuthentication(authUserModel: UserAuthModel) {
    this.authUser.next(authUserModel);
    this.userInterfaceService.setAuthentication(true); 
    
  }

  getAuthentication(): Observable<UserAuthModel> {  
    return this.authUser.asObservable();
  }

  getAnagraficaLogin(email: string): Observable<AnagraficaModel> {
    return  this.http.get(this.configService.getWebAPIurl() + 'api/Anagrafica/GetAnagraficaLogin/' + email);
  }

 logonUser(email: string, password: string): Observable<AnagraficaModel> {
    return  this.http.get(this.configService.getWebAPIurl() + 'api/Anagrafica/LogonUser/' + email + "/"+password);
  }


}
